import { ComponentProps } from "react";

import { Input } from "../Input/Input";
import { InputBox } from "../InputBox/InputBox";

type Props = ComponentProps<typeof Input>;

export const TextField = (props: Props) => {
  return (
    <InputBox>
      <Input {...props} />
    </InputBox>
  );
};
